export class Utils {
  /**
   * Format string or number to money format
   * @param amount
   * @param currency
   * @returns {string}
   */
  static formatMoney = (amount, currency) => {
    let _decimalCount = 2
    let _decimal = ","
    let _thousands = "."
    let _currency = currency || ""
    let _amount

    if (typeof amount === "number") {
      _amount = amount
    } else {
      try {
        _amount = parseInt(amount)
      } catch (e) {
        _amount = 0
      }
    }

    if (!isNaN(_amount)) {
      _amount = _amount / 100
      _amount = _amount.toFixed(_decimalCount)
      _amount = _amount.replace(/\./g, _decimal)
      _amount = _amount.replace(/\B(?=(\d{3})+(?!\d))/g, _thousands)
      _amount = _currency + _amount
      return _amount
    } else {
      return ""
    }
  }

  /**
   * Unique key generator for elements
   * @returns {string}
   */
  static generateUniqueId() {
    const now = new Date()
    return `id_${now.getTime()}_${Math.round(Math.random() * 1000)}`
  }

  /**
   * Validate and format CSS units
   * @param unit
   * @returns {string}
   */
  static parseUnit(unit) {
    if (typeof unit === "number") {
      return unit === 0 ? `${unit}` : `${unit}px`
    } else if (
      typeof unit === "string" &&
      /^[\d]+(%|vh\b|vw\b|rem\b)?$/.test(unit)
    ) {
      return unit
    }
    console.warn("Unidade de medida incorreta", unit)
    return "inherit"
  }

  static attatchPropToStyle(style, propName, propValue) {
    try {
      if (
        Utils.truth(propValue) &&
        Utils.truth(propName) &&
        Utils.truth(style)
      ) {
        style[propName] = propValue
        return style
      } else {
        return style
      }
    } catch (e) {
      console.warn("Invalid CSS property or Value", propName, propValue)
      return style
    }
  }

  static setPropValue(style, propName, propValue) {
    try {
      if (
        Utils.truth(propValue) &&
        Utils.truth(propName) &&
        Utils.truth(style)
      ) {
        propValue = Math.round((propValue * 100) / 16) / 100
        style[propName] = `${propValue}rem`
        return style
      } else {
        return style
      }
    } catch (e) {
      console.warn("Invalid CSS property or Value", propName, propValue)
      return style
    }
  }

  static getValueFromArray(valueArray) {
    if (Array.isArray(valueArray) && valueArray.length) {
      valueArray = valueArray.filter(
        x => !(typeof x === "undefined" || x === null),
      )
      if (valueArray.length) {
        return valueArray[valueArray.length - 1]
      } else {
        return 0
      }
    } else {
      return 0
    }
  }

  /**
   * Evaluate if sentences are true
   * @param data
   * @returns {boolean}
   */
  static truth(data) {
    let type = typeof data

    if (type === "undefined" || !data) {
      return false
    } else if (data instanceof Array) {
      return data.length > 0
    } else if (type === "string") {
      return data.trim().length > 0
    } else if (type === "number") {
      return data !== 0
    } else if (type === "object" || type === "function") {
      return true
    } else {
      return data === true
    }
  }

  /**
   * Filter
   * @param {Object} styleObject
   * @param {Array} propArray
   * @returns {Object} newStyleObject
   */
  static filterStyleProps = (styleObject, propArray) => {
    let newStyleObject = {}
    if (
      styleObject &&
      typeof styleObject === "object" &&
      Array.isArray(propArray)
    ) {
      Object.keys(styleObject).forEach(key => {
        if (propArray.some(prop => prop === key)) {
          newStyleObject[key] = styleObject[key]
        } else {
          console.warn(`Property '${key}' is not allowed on style property.`)
        }
      })
    }
    return newStyleObject
  }

  static getGlobalCSSValues = ["inherit", "initial", "unset"]
}
